import React from 'react';
import { router } from '@inertiajs/react';

export default function ImpersonationBanner({ isImpersonating, originalAdmin }) {
  if (!isImpersonating) {
    return null;
  }

  const handleReturnToAdmin = () => {
    if (confirm('Are you sure you want to return to your admin account?')) {
      router.post(route('admin.user.leave-impersonation'));
    }
  };

  return (
    <div className="bg-orange-500 text-white py-2 px-4 text-center">
      <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4 space-y-2 md:space-y-0">
        <div className="flex items-center space-x-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          <span>
            You are in <strong>read-only mode</strong>, currently logged in as another user. User
            activity tracking is disabled.
            {originalAdmin && ` Your admin account is ${originalAdmin.email}.`}
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="bg-orange-700 text-white text-xs font-medium px-2.5 py-0.5 rounded">
            Read-only mode
          </span>
          <button
            onClick={handleReturnToAdmin}
            className="bg-white text-orange-600 px-3 py-1 rounded-md text-sm font-medium hover:bg-orange-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Return to Admin
          </button>
        </div>
      </div>
    </div>
  );
}
